mutation DepartmentBudgetUpdate($input: DepartmentBudgetUpdateInput!) {
  departmentBudgetUpdate(input: $input) {
    clientMutationId
  }
}
